
import { PaymentProviderEnum } from '../lib/enums';
import { applicationStartup, login } from '../lib/store/common-actions';

import { MOCK } from '../configDebug';
import configLib from '../configLib';

import { UI_ROUTES } from './routes';

export const handleOpenFileInNewTab = (file: string, type: string, isMobile: boolean) => {
  const base64toBlob = (base64Data: string) => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; sliceIndex += 1) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; i += 1, offset += 1) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type });
  };
  const blob = base64toBlob(file);
  const blobUrl = URL.createObjectURL(blob);
  if (isMobile) {
    window.open(blobUrl, '_self');
  } else {
    window.open(blobUrl);
  }
};

export const startMockedMode = () => {
  MOCK.setEnabled(true);
  configLib.store.dispatch(applicationStartup());
  configLib.store.dispatch(login({ authType: 'login' }));
};

export const getTabName = (location, isReferralsEnabled?: boolean) => {
  if (location.pathname === UI_ROUTES.overview) return 'Watchlist';
  if (location.pathname === UI_ROUTES.dashboard) return 'My Account';
  if (location.pathname === UI_ROUTES.discover) return 'Discover';
  if (location.pathname === UI_ROUTES.payouts) return isReferralsEnabled ? 0 : 'Payouts';
  if (location.pathname === UI_ROUTES.referrals) return 'Referrals';
  if (location.pathname === UI_ROUTES.tradeHistory) return 'Trade History';
  if (location.pathname === UI_ROUTES.myProfile) return 'Profile';
  return 0;
};

/** Title shown in the mobile header once the screen's own title scrolls under it. */
export const getSubPageName = (location): string | null => {
  if (location.pathname === UI_ROUTES.myAccountPersonalDetails) return 'Personal Details';
  if (location.pathname === UI_ROUTES.discover + UI_ROUTES.epicMoversToday) return 'Epic Movers';
  if (location.pathname === UI_ROUTES.discover + UI_ROUTES.fiftyTwoWeekHighLow) return '52-Week Gainers & Losers';
  if (location.pathname === UI_ROUTES.discover + UI_ROUTES.marketCapRadar) return 'Market Cap Radar';
  if (location.pathname === UI_ROUTES.discover + UI_ROUTES.gapTrackers) return 'Gap Tracker';
  if (location.pathname.startsWith(`${UI_ROUTES.discover}${UI_ROUTES.popularGroup}/`)) {
    return location.state?.sector || 'Popular Groups';
  }
  if (location.pathname === UI_ROUTES.discover + UI_ROUTES.dividendPayersAndHighGrowthCompaniesPath) {
    return 'Long Term Investments';
  }
  if (location.pathname === UI_ROUTES.discover + UI_ROUTES.earningsCalendar) return 'Earnings Calendar';
  return null;
};

export const preparePaymentErrorPathByPaymentProvider = (paymentProvider: PaymentProviderEnum): string =>
  `${UI_ROUTES.paymentError}?paymentProvider=${paymentProvider}`;

export const formatFinancialNumber = (num: number | string, index?: number) => {
  if (num === undefined || num === null) return '-';
  if (typeof num === 'string') return num;
  if ((num as number).toString().length > 4 && num.toString().includes('.')) return (num as number).toFixed(2);
  if (index && index % 2 !== 0) return '';
  if (num <= 1000 && num >= -1000) return num;
  const operator = num < 0 ? '-' : '';
  if (Math.abs(num) >= 1000000000) return `${operator}${(Math.abs(num) / 1000000000).toFixed(1)}b`;
  if (Math.abs(num) >= 1000000) return `${operator}${(Math.abs(num) / 1000000).toFixed(1)}m`;
  return `${operator}${(Math.abs(num) / 1000).toFixed(0)}k`;
};
